export default __webpack_public_path__ + "static/media/poster.b2a63007.jpg";